import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import SingleVideo from "../Components/SingleVideo";
import Events from "../Components/Events";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import axios from "axios";
import { getCookie, eraseCookie } from "./utils";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@mui/material/Alert";

function Container() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  useEffect(() => {
    const its = getCookie("ITS_ID");
    const token = getCookie("SESSION_TOKEN");
    if (its && token) {
      axios
        .post("/OneLogin/CheckLogin.php", { Id: its, Token: token })
        .then((res) => {
          if (res.data.status === "Valid") setLoggedIn(true);
          else clearSession();
        })
        .catch(() => clearSession());
    }
  }, []);

  const clearSession = () => {
    eraseCookie("ITS_ID");
    eraseCookie("SESSION_TOKEN");
    setLoggedIn(false);
  };

  const handleLogout = async () => {
    try {
      // hit the API; we await so errors can be caught below
      await axios.post("/OneLogin/Logout.php", { Id: getCookie("ITS_ID") });
    } catch (err) {
      console.error("Logout API failed:", err);
      // optional: surface a different snackbar message on failure
    } finally {
      // runs whether the request succeeded or threw
      clearSession();
      setSnackbarMessage("User logged out!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            loggedIn ? (
              <Navigate to="/ActiveEvents" />
            ) : (
              <>
                <Login loggedIn={setLoggedIn} />
                <Footer color={"grey"} bgcolor={"white"} />
              </>
            )
          }
        />
        <Route
          path="/ActiveEvents"
          element={
            loggedIn ? (
              <>
                <Header logout={handleLogout} />
                <Events />
                <Footer color={"red"} />
              </>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/SingleVideo"
          element={
            loggedIn ? (
              <>
                <Header logout={handleLogout} />
                <SingleVideo />
                {/* <Footer color={"red"} /> */}
              </>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="*" element={<p>Page not Found !!</p>} />
      </Routes>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default Container;
